<template>
  <nav class="navbar navbar-expand-lg navbar-byteark">
    <button type="button"
      class="navbar-toggler"
      aria-label="Toggle navigation"
      @click.stop="onToggleMenu">
      <i class="fas fa-bars"></i>
    </button>
    <slot
      name="navbar-brand"
      v-if="$slots['navbar-brand']" />
    <slot
      name="navbar-nav-search"
      v-if="$slots['navbar-nav-search']" />
    <slot
      name="navbar-nav"
      v-if="$slots['navbar-nav']" />
    <ul class="navbar-nav navbar-nav-user"
      :class="{'ml-auto': !$slots['navbar-nav']}"
      @click="onToggleShowUserMenu()"
      v-if="user">
      <li class="nav-item">
        <div class="username">
          {{ cutString(user.name)}}
        </div>
        <div class="logo"
          :style="{ backgroundColor: colorGenerator(user.name) }">
          <span>{{user.name.charAt(0) }}</span>
        </div>
        <div class="sub-menu"
          v-if="state.isShowUserMenu">
          <div class="nav-item"
            v-if="user.team">
            <div class="user-item">
              <label>Team</label>
              <div class="user-item-value">
                {{user.team.name}}
              </div>
            </div>
            <div class="user-item">
              <label>Email</label>
              <div class="user-item-value">
                {{user.email}}
              </div>
            </div>
          </div>
          <slot
            name="menu-user"
            v-if="$slots['menu-user']" />
        </div>
      </li>
    </ul>
  </nav>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import colorGenerator from '@/utils/colorGeneratorUtils';
// import colorGenerator from '../utils/colorGeneratorUtils';

export default {
  mixins: [colorGenerator],
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    onToggleMenu: {
      type: Function,
      default: () => {},
    },
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      state: {
        isShowUserMenu: false,
      },
    };
  },
  methods: {
    onToggleShowUserMenu() {
      this.state.isShowUserMenu = !this.state.isShowUserMenu;
    },
    cutString(string) {
      if (string.length > 12) {
        return `${string.substring(0, 12)} ...`;
      }
      return string;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/navbar.scss';
</style>
